import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'

/**
 * 营销中心（promotion）隐藏页路由
 *
 * 遵循《紫金山 SaaS 模块开发规范》§12.2 / §16：
 *   - 业务菜单**不在前端定义**，全部由后端 `system_menu` 表动态生成；
 *   - 本文件**只放隐藏页**（活动编辑 / 详情 / 预览），全部 `meta.hidden = true`；
 *   - 文件名必须与 `system_module.name`（= `promotion`）一致。
 *
 * ⚠️ 注册方式（易漏）：`src/router/index.ts` 只显式加载 `remaining` / `mall` /
 *   `standalone-apps` 三个模块，**不会自动扫描本目录**。本文件由
 *   `router/modules/remaining.ts` 显式 `import` 并展开，若漏了那一步，
 *   本文件就是死代码，隐藏页一律落 404。
 *
 * ⚠️ 路径决策：这里用扁平根 `/promotion`，与 `standalone-apps.ts` 里给独立窗用的
 *   `/ai-Application-center/promotion` 并存。二者不冲突：
 *   - `/ai-Application-center/...` 由 AI 应用中心前缀副本机制自动生成（见
 *     `router/aiApplicationCenter.ts`，`promotion` 已在 `MODULE_CENTER_PREFIXES` 中）；
 *   - 扁平 `/promotion` 是 `utils/standaloneApp.ts` 里 `rewritePromotionLegacyPath`
 *     所依赖的基路径（`/promotion` → `/promotion/overview`）。
 *
 * 2026-09-16 营销中心合并开发 P2：本文件新建。
 */

/** 活动管理列表页（商城营销中心 → 游戏抽奖） */
const ACTIVITY_MENU_PATH = '/mall/promotion/game-lottery/activity-manage'

const promotionRoutes: AppRouteRecordRaw[] = [
  {
    path: '/promotion',
    component: Layout,
    name: 'PromotionCenter',
    meta: { hidden: true },
    children: [
      {
        path: 'activity/edit/:id?',
        name: 'PromotionActivityEdit',
        meta: {
          title: '活动编辑',
          hidden: true,
          noCache: true,
          activeMenu: ACTIVITY_MENU_PATH
        },
        component: () => import('@/views/promotion/activity/PortalEditorPage.vue')
      },
      {
        path: 'activity/detail/:id',
        name: 'PromotionActivityDetail',
        meta: {
          title: '活动详情',
          hidden: true,
          noCache: true,
          activeMenu: ACTIVITY_MENU_PATH
        },
        component: () => import('@/views/promotion/activity/Detail.vue')
      },
      {
        path: 'activity/preview/:id',
        name: 'PromotionActivityPreview',
        meta: {
          title: '活动预览',
          hidden: true,
          noCache: true,
          activeMenu: ACTIVITY_MENU_PATH
        },
        component: () => import('@/views/promotion/activity/Preview.vue')
      }
    ]
  }
]

export default promotionRoutes
